var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
import axios from "axios";
import { Box, IconButton, Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, } from "@material-ui/core";
import { MoreVert } from "@material-ui/icons";
import { usePagination } from "frontend/src/lib/pagination";
import { TableRowsSkeleton } from "frontend/src/ui/table-skeleton";
import { MusicArchivesTableRow } from "./music-archives-table-row";
import { useSearchMusicArchives } from "frontend/src/domain/music-archives";
var MusicArchives = React.memo(function (_a) {
    var musicArchives = _a.musicArchives;
    var _b = __read(React.useState(musicArchives), 2), musicArchivesState = _b[0], setMusicArchives = _b[1];
    var setIsChecked = function (id) {
        var newMusicArchives = __spreadArray([], __read(musicArchivesState), false);
        var targetMusicArchive = newMusicArchives.find(function (x) { return x.id == id; });
        targetMusicArchive.isChecked = !targetMusicArchive.isChecked;
        setMusicArchives(newMusicArchives);
    };
    var musicArchiveIds = musicArchivesState.filter(function (x) { return x.isChecked; }).map(function (x) { return x.id; });
    var _c = __read(React.useState(null), 2), anchor = _c[0], setAnchor = _c[1];
    var close = function () { return setAnchor(null); };
    var handleClick = function (event) {
        setAnchor(event.currentTarget);
    };
    var unpublish = function () {
        console.log("unpublish", musicArchiveIds);
        var payload = { "musicArchives": musicArchiveIds.map(function (x) { return ({ id: x, is_approved: false }); }) };
        axios
            .put("/api/v2/musicArchives", payload)
            .then(function () {
            var newMusicArchives = __spreadArray([], __read(musicArchivesState), false);
            newMusicArchives.forEach(function (musicArchive) {
                if (musicArchiveIds.includes(musicArchive.id)) {
                    // musicArchive.is_approved = false;
                }
            });
            setMusicArchives(newMusicArchives);
            alert("Треки сняты с публикации");
        })
            .catch(function (err) {
            console.warn(err);
        });
    };
    return (React.createElement(React.Fragment, null,
        musicArchivesState.map(function (_a) {
            var id = _a.id, client_id = _a.client_id, playlist_id = _a.playlist_id, is_processing = _a.is_processing, is_ready = _a.is_ready, filename = _a.filename, isChecked = _a.isChecked;
            return (React.createElement(MusicArchivesTableRow, { key: id, id: id, clientId: client_id, playlistId: playlist_id, isProcessing: is_processing, isReady: is_ready, filename: filename, isChecked: isChecked, setIsChecked: setIsChecked }));
        }),
        React.createElement(TableRow, null,
            React.createElement(TableCell, { colSpan: 6 },
                "\u041E\u0442\u043C\u0435\u0447\u0435\u043D\u043E: ",
                musicArchiveIds.length,
                " \u00A0 \u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0441 \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u043C\u0438:",
                React.createElement(IconButton, { size: "small", onClick: handleClick },
                    React.createElement(MoreVert, null)),
                React.createElement(Menu, { anchorEl: anchor, keepMounted: true, open: Boolean(anchor), onClose: close },
                    React.createElement(MenuItem, { onClick: function () { unpublish(); close(); } }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"))))));
});
export var MusicArchivesSearchResultTable = function (_a) {
    var params = _a.params;
    var _b = usePagination({ page: 0, rowsPerPage: 25, pageResetDeps: [params] }), page = _b.page, rowsPerPage = _b.rowsPerPage, skip = _b.skip, onChangeRowsPerPage = _b.onChangeRowsPerPage, onChangePage = _b.onChangePage;
    var data = useSearchMusicArchives({
        skip: skip,
        limit: rowsPerPage,
        clientId: null,
        playlistId: null
    }).data;
    var musicArchives = data ? data.items : [];
    var checkableMusicArchives = musicArchives.map(function (musicArchive) {
        var checkableMusicArchive = musicArchive;
        checkableMusicArchive.isChecked = false;
        return checkableMusicArchive;
    });
    return (React.createElement(Box, null,
        React.createElement(TableContainer, null,
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null),
                        React.createElement(TableCell, null, "ID"),
                        React.createElement(TableCell, null, "\u041F\u043B\u0435\u0439\u043B\u0438\u0441\u0442"),
                        React.createElement(TableCell, null, "\u041A\u043B\u0438\u0435\u043D\u0442"),
                        React.createElement(TableCell, null, "\u0421\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435"),
                        React.createElement(TableCell, null))),
                React.createElement(TableBody, null, data ? (React.createElement(MusicArchives, { musicArchives: checkableMusicArchives })) : (React.createElement(TableRowsSkeleton, { rows: rowsPerPage, columns: 8 }))))),
        data && (React.createElement(TablePagination, { component: "div", count: data.total, page: page, onPageChange: onChangePage, rowsPerPage: rowsPerPage, onRowsPerPageChange: onChangeRowsPerPage, labelRowsPerPage: "Показывать архивов" }))));
};
